module.exports = __webpack_public_path__ + "static/media/leader_notes_detailed.06e2a57f.pdf";